import { createContext, useContext, useState } from 'react';

const teamsContext = createContext();

export const TeamsProvider = ({ children }) => {
    const [team1, setTeam1] = useState([])
    const [team2, setTeam2] = useState([])
  
    return (
      <teamsContext.Provider value={{ team1, setTeam1, team2, setTeam2 }}>
        {children}
      </teamsContext.Provider>
    )
  }
  
export const useTeams = () => {
const { team1, setTeam1, team2, setTeam2 } = useContext(teamsContext)
return { team1, setTeam1, team2, setTeam2 }
}